document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.video-container');
    const videoWrappers = document.querySelectorAll('.video-wrapper');
    const videos = document.querySelectorAll('video');
    const playPauseBtns = document.querySelectorAll('.play-pause-btn');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');
    const dots = document.querySelectorAll('.dot');
    
    let currentIndex = 0;
    const totalVideos = videos.length;
    let startX = 0;
    let currentX = 0;
    let isMobile = window.innerWidth <= 768;
    let isDragging = false;

    // 添加弹窗相关元素
    const videoModal = document.querySelector('.video-modal');
    const modalVideo = document.querySelector('#modal-video');
    const modalClose = document.querySelector('.modal-close');
    const modalOverlay = document.querySelector('.modal-overlay');
    const modalPlayPauseBtn = document.querySelector('.modal-play-pause-btn');
    const modalVideoWrapper = document.querySelector('.modal-video-wrapper');

    window.addEventListener('resize', () => {
        isMobile = window.innerWidth <= 768;
    });

    // 更新播放/暂停按钮状态
    function updatePlayPauseState(index) {
        const wrapper = videoWrappers[index];
        const video = videos[index];
        if (wrapper && video) {
            if (video.paused) {
                wrapper.classList.remove('playing');
            } else {
                wrapper.classList.add('playing');
            }
        }
    }

    // 播放/暂停处理函数
    function togglePlayPause(index) {
        const video = videos[index];
        // const videoTitle = videoWrappers[index].querySelector('.video-title').textContent;
        
        // 暂停所有视频
        videos.forEach((otherVideo, i) => {
            if (!otherVideo.paused) {
                otherVideo.pause();
                otherVideo.currentTime = 0;
                updatePlayPauseState(i);
            }
        });

        // 在弹窗中播放视频
        modalVideo.src = video.src;
        // 更新弹窗中的视频标题
        // document.querySelector('.modal-video-info .video-title').textContent = videoTitle;
        videoModal.classList.add('active');
        modalVideo.play();
    }

    // 为每个播放/暂停按钮添加点击事件
    playPauseBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const index = parseInt(btn.dataset.index);
            togglePlayPause(index);
        });
    });

    // 为视频添加播放/暂停状态监听
    videos.forEach((video, index) => {
        video.addEventListener('play', () => updatePlayPauseState(index));
        video.addEventListener('pause', () => updatePlayPauseState(index));
    });

    function updateCarousel(newIndex, animate = true) {
        // 暂停当前视频
        videos[currentIndex].pause();
        videos[currentIndex].currentTime = 0;
        updatePlayPauseState(currentIndex);
        
        if (!isMobile) {
            const slideWidth = 280;
            const gap = 15;
            const slideOffset = (slideWidth + gap) * newIndex;
            
            container.style.transition = animate ? 'transform 0.3s ease' : 'none';
            container.style.transform = `translateX(-${slideOffset}px)`;
        } else {
            const offset = newIndex * 86;
            container.style.transition = animate ? 'transform 0.3s ease' : 'none';
            container.style.transform = `translateX(-${offset}vw)`;
        }
        
        currentIndex = newIndex;
    }

    // PC端按钮控制
    if (prevBtn && nextBtn) {
        const updateButtonState = () => {
            prevBtn.disabled = currentIndex === 0;
            nextBtn.disabled = currentIndex === totalVideos - 1;
            prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
            prevBtn.style.cursor = currentIndex === 0 ? 'not-allowed' : 'pointer';
            nextBtn.style.opacity = currentIndex === totalVideos - 1 ? '0.5' : '1';
            nextBtn.style.cursor = currentIndex === totalVideos - 1 ? 'not-allowed' : 'pointer';
        };

        nextBtn.addEventListener('click', () => {
            if (!isMobile && currentIndex < totalVideos - 1) {
                const newIndex = currentIndex + 1;
                updateCarousel(newIndex);
                updateButtonState();
            }
        });

        prevBtn.addEventListener('click', () => {
            if (!isMobile && currentIndex > 0) {
                const newIndex = currentIndex - 1;
                updateCarousel(newIndex);
                updateButtonState();
            }
        });

        updateButtonState();
    }

    // 修改触摸事件处理
    container.addEventListener('touchstart', (e) => {
        if (!isMobile) return;
        // 如果点击的是播放按钮，不启动滑动
        if (e.target.closest('.play-pause-btn')) return;
        
        startX = e.touches[0].clientX;
        isDragging = true;
        container.style.transition = 'none';
    });

    container.addEventListener('touchmove', (e) => {
        if (!isDragging || !isMobile) return;
        // 如果点击的是播放按钮，不处理滑动
        if (e.target.closest('.play-pause-btn')) return;
        
        currentX = e.touches[0].clientX;
        const diff = currentX - startX;
        const offset = -(currentIndex * 90) + diff / window.innerWidth * 100;
        container.style.transform = `translateX(${offset}vw)`;
    });

    container.addEventListener('touchend', (e) => {
        if (!isDragging || !isMobile) return;
        // 如果点击的是播放按钮，不处理滑动
        if (e.target.closest('.play-pause-btn')) return;
        
        isDragging = false;
        const diff = currentX - startX;
        const threshold = window.innerWidth * 0.2;

        if (Math.abs(diff) > threshold) {
            const newIndex = diff > 0 
                ? Math.max(currentIndex - 1, 0)
                : Math.min(currentIndex + 1, totalVideos - 1);
            updateCarousel(newIndex);
        } else {
            updateCarousel(currentIndex);
        }
    });

    // 更新弹窗视频的播放/暂停状态
    function updateModalPlayPauseState() {
        if (modalVideoWrapper && modalVideo) {
            if (modalVideo.paused) {
                modalVideoWrapper.classList.remove('playing');
                modalVideoWrapper.classList.add('show-controls');
                modalVideoWrapper.classList.add('show-play-button');
            } else {
                modalVideoWrapper.classList.add('playing');
                if (isMobile) {
                    modalVideoWrapper.classList.add('show-controls');
                    modalVideoWrapper.classList.add('show-play-button');
                    startHideControlsTimer();
                }
            }
        }
    }

    // 处理弹窗视频的播放/暂停
    function toggleModalPlayPause() {
        if (modalVideo && modalVideoWrapper) {
            if (modalVideo.paused) {
                modalVideo.play();
            } else {
                modalVideo.pause();
            }
            updateModalPlayPauseState();
        }
    }

    // 添加弹窗视频的事件监听
    modalVideo.addEventListener('play', updateModalPlayPauseState);
    modalVideo.addEventListener('pause', updateModalPlayPauseState);
    modalPlayPauseBtn.addEventListener('click', toggleModalPlayPause);

    // 更新关闭弹窗的处理函数
    function closeModal() {
        if (modalVideo && modalVideoWrapper && videoModal) {
            modalVideo.pause();
            modalVideo.currentTime = 0;
            modalVideo.src = '';
            videoModal.classList.remove('active');
            modalVideoWrapper.classList.remove('playing');
            modalVideoWrapper.classList.remove('show-controls');
            modalVideoWrapper.classList.remove('show-play-button');
            clearTimeout(hideControlsTimer);
        }
    }

    modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', closeModal);

    // 监听鼠标事件
    modalVideoWrapper.addEventListener('mouseenter', () => {
        if (!isMobile) {
            modalVideoWrapper.classList.add('show-controls');
        }
    });

    modalVideoWrapper.addEventListener('mouseleave', () => {
        if (!isMobile) {
            modalVideoWrapper.classList.remove('show-controls');
        }
    });

    // 修改点击和触摸事件监听
    modalVideo.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!isMobile) {  // PC 端点击时暂停/播放视频
            toggleModalPlayPause();
        } else {  // 移动端显示控件和暂停按钮
            modalVideoWrapper.classList.remove('show-controls');
            modalVideo.controls = true;  // 强制显示原生控件
            requestAnimationFrame(() => {
                modalVideoWrapper.classList.add('show-controls');
                modalVideoWrapper.classList.add('show-play-button');
                startHideControlsTimer();
            });
        }
    });

    modalVideo.addEventListener('touchend', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!isDragging) {
            modalVideoWrapper.classList.remove('show-controls');
            modalVideo.controls = true;  // 强制显示原生控件
            requestAnimationFrame(() => {
                modalVideoWrapper.classList.add('show-controls');
                modalVideoWrapper.classList.add('show-play-button');
                startHideControlsTimer();
            });
        }
    });

    // 添加控件自动隐藏的定时器
    let hideControlsTimer;
    function startHideControlsTimer() {
        clearTimeout(hideControlsTimer);
        hideControlsTimer = setTimeout(() => {
            if (!modalVideo.paused) {
                modalVideoWrapper.classList.remove('show-controls');
                modalVideoWrapper.classList.remove('show-play-button');
            }
        }, 3000); // 3秒后隐藏
    }
}); 